import { apiFetch } from './api';

// ─── TYPES ──────────────────────────────────────────────────────────────────

export interface Issue {
  id: string;
  homeId: string;
  assetId?: string | null;
  title: string;
  description?: string | null;
  severity: 'low' | 'medium' | 'high' | 'critical';
  status: 'open' | 'in_progress' | 'resolved' | 'closed';
  createdAt: string;
  resolvedAt?: string | null;
  asset?: { id: string; name: string } | null;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

// ─── API FUNCTIONS ──────────────────────────────────────────────────────────

export const getIssues = async (homeId: string, status?: string): Promise<Issue[]> => {
  const params = new URLSearchParams({ homeId });
  if (status) params.set('status', status);
  const res = await apiFetch<ApiResponse<Issue[]>>(`/v1/issues?${params.toString()}`);
  return res.data;
};
